import { useEffect } from 'react';

export const higherCompulsory = ['বাংলা', 'ইংরেজি', 'তথ্য ও যোগাযোগ প্রযুক্তি'];
export function subjectLevel(institution, classApplied = '') {
  if (institution === 'honors' || institution === 'kcns') return null;
  const cls = classApplied.replace(/[০-৯]/g, digit => '০১২৩৪৫৬৭৮৯'.indexOf(digit));
  if (/\b(XI|XII|11|12|HSC)\b|একাদশ|দ্বাদশ|উচ্চ মাধ্যমিক/i.test(cls)) return 'higher';
  if (/\b(VI|VII|VIII|IX|X|6|7|8|9|10|SSC)\b|ষষ্ঠ|সপ্তম|অষ্টম|নবম|দশম|মাধ্যমিক/i.test(cls)) return 'secondary';
  return null;
}
export function subjectChoices(institution, classApplied, application = {}, enrollment = {}) {
  return {
    compulsory: enrollment.compulsory ?? application.compulsory ?? (subjectLevel(institution, classApplied) === 'higher' ? [...higherCompulsory] : []),
    optional: enrollment.optional ?? application.optional ?? []
  };
}

export default function SubjectFields({ institution, classApplied, value = {}, onChange }) {
  const level = subjectLevel(institution, classApplied);
  useEffect(() => {
    if (level === 'higher' && value.compulsory === undefined) {
      onChange({ ...value, compulsory: [...higherCompulsory] });
    }
  }, [level, value, onChange]);
  if (!level) return null;
  return <fieldset className="space-y-4 rounded-xl border border-line p-4">
    <legend className="px-2 font-semibold">কি কি বিষয় নিতে ইচ্ছুক / Intended subjects</legend>
    <p className="text-sm font-semibold">{level === 'higher' ? 'উচ্চ মাধ্যমিক / Higher secondary' : 'মাধ্যমিক / Secondary'}</p>
    <p className="text-sm text-muted">Enter subjects as advised by the school. Final choices are subject to school approval.</p>
    <div className="grid gap-5 sm:grid-cols-2">{[['compulsory', 'আবশ্যিক / Compulsory'], ['optional', 'নৈর্বাচনিক/ঐচ্ছিক / Elective / optional']].map(([key, label]) => <div key={key} className="space-y-3">
      <h4 className="font-semibold">{label}</h4>
      {(value[key] || []).map((subject, index) => <div key={index} className="flex items-center gap-2">
        <label className="flex-1"><span className="sr-only">{label} subject {index + 1}</span><input className="w-full rounded-lg border border-line px-3 py-2 text-sm" maxLength={120} value={subject} onChange={event => onChange({ ...value, [key]: value[key].map((item, i) => i === index ? event.target.value : item) })} /></label>
        <button type="button" className="text-sm underline" aria-label={`Remove ${key} subject ${index + 1}`} onClick={() => onChange({ ...value, [key]: value[key].filter((_, i) => i !== index) })}>Remove</button>
      </div>)}
      <button type="button" className="text-sm font-semibold text-green underline" disabled={(value[key] || []).length >= 20} onClick={() => onChange({ ...value, [key]: [...(value[key] || []), ''] })}>Add {key === 'optional' ? 'elective / optional' : 'compulsory'} subject</button>
    </div>)}</div>
  </fieldset>;
}
